<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog">
      <el-table :data="tableData" ref="multipleTable"  @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column label="订单编号" prop="OrderNo" min-width="130" />
          <el-table-column label="工单编号" prop="WorkDocNo" min-width="130" />
          <el-table-column label="质检数量" prop="TestQuantity" min-width="130" />
          <el-table-column label="合格数量" prop="PassQuantity" min-width="110" />
          <el-table-column label="需返工数量" prop="FailQuantity" width="110" />
      </el-table>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" >确定</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import dialogMixins from "@/mixins/dialog";

export default {
  components: { commonDialog, },
  mixins: [dialogMixins],
  props: {
    title: {
      type: String,
      default: "不合格工单",
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require("@/api/pu/prTestRework").default,
      tableData: [],
      list: [],
    };
  },
  created(){
    this.api.getWorkDocTestFailList({}).then(res => {
      if(res.Code === 0){
        this.tableData = res.Data;
      }
    })
  },
  methods: {
    handleSelectionChange(list){
      this.list = list;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      },
    selectMultiple(){
      if(this.list.length === 0){
        this.$message({type: 'warning', message: "请先勾选记录"})
        return 
      }
      this.$emit('select', this.list)
      this.toggleSelection()
      this.close();
    }
  },
};
</script>